





























































import { Component, Vue } from 'vue-property-decorator';
import { BButton, BFormInput } from 'bootstrap-vue';
import BaseCard from '@/components/BaseCard.vue';

@Component({
    name: 'ResetPasswordView',
    components: {
        'base-card': BaseCard,
        'b-button': BButton,
        'b-form-input': BFormInput,
    },
})
export default class ResetPasswordView extends Vue {
    updating = false;
    error = '';
    password = '';
    passwordConfirm = '';

    async recover() {
        const token = this.$router.currentRoute.params.token;

        if (!this.password.length || !this.passwordConfirm.length) {
            return;
        }

        if (this.password !== this.passwordConfirm) {
            this.error = 'Please enter the same password again.';
            return;
        }

        this.updating = true;

        try {
            const { response }: any = await this.$store.dispatch('account/resetPassword', {
                token,
                plainPassword: this.password,
            });

            if (response && response.status === 403) {
                throw Error(response.data.message);
            }

            this.$router.push('/');
        } catch (e) {
            this.error = e.toString();
        } finally {
            this.updating = false;
        }
    }
}
